/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { apiGet } from "./Api/apiCall";
import { AvailableDocumentRecipient } from "../types/AvailableDocumentRecipient";
import { CaseOrganization } from "../types/CaseOrganization";
import { ProductUnion } from "../types/ProductUnion";
import { Person } from "../types/Person";
import { translate } from "./Translations/translatorService";

export const fetchAvailableDocumentRecipients = (product: ProductUnion): Promise<AvailableDocumentRecipient[]> =>
  apiGet(
    `lb/services/generate_case_file/available_recipients/${encodeURIComponent(product.productClassName)}/${product.id}`,
  );

export const getOrganizationRecipient = (product: ProductUnion, recipientType: string): CaseOrganization | null => {
  const match = /^processParticipantsOrganizations\.([0-9]+)$/.exec(recipientType);
  return match
    ? product.processParticipantsOrganizations?.find((entry: CaseOrganization) => String(entry.id) === match[1]) ?? null
    : null;
};

export const getDocumentRecipientRole = (product: ProductUnion, recipientType: string): string | null => {
  const personId = /^processParticipantsPeople\.([0-9]+)$/.exec(recipientType)?.[1];
  const labelType = personId
    ? product.processParticipantsPeople?.find((person: Person) => String(person.id) === personId)?.labelType
    : getOrganizationRecipient(product, recipientType)?.organization.labelType;

  // Use only the stored role; recipient labels also contain personal or company names.
  return labelType && labelType !== "other" ? translate("participant.labelType.values." + labelType) : null;
};
